import * as React from "react"
import { TextField, Dialog, FlatButton, SelectField, MenuItem, Toggle } from "material-ui"
import strings from "../../localization/strings"
import autobind from "class-autobind"
import { IExtendedUserExceptionNotificationSetting, ENotifyMethods, EExceptionUITypes } from "../../models"
import * as notifyHelper from "../../helpers/notifyHelper"
import { EnumValues } from "enum-values"
import AuthenticationStore from "../../stores/AuthenticationStore"
import AccountStore from "../../stores/AccountStore"
import ChooseHierarchyChip from "../../components/hierarchy/choose_hierarchy/ChooseHierarchyChip"
import NotifyMethodsChip from "./notifyMethodsChip/NotifyMethodsChip"
import { red500 } from "material-ui/styles/colors"
interface IProps {
	existingSubscriptions: IExtendedUserExceptionNotificationSetting[]
	editSubscription: IExtendedUserExceptionNotificationSetting
	handleClose(): void
	handleAdd(subscription: IExtendedUserExceptionNotificationSetting): void
	handleUpdate(subscription: IExtendedUserExceptionNotificationSetting): void
}
interface IState {
	exceptionType: EExceptionUITypes
	errorExceptionType: string
	notifyMethods: ENotifyMethods[]
	errorNotifyMethod: string
	hierarchyId: string
	includeChildHierarchies: boolean
	restrictToDirectReports: boolean
	description: string
	errorDuplicated: string
}

export default class AddSupervisorNotificationSettingDialog extends React.Component<IProps, IState> {
	constructor(props: IProps) {
		super(props)
		this.state = {
			exceptionType: props.editSubscription ? props.editSubscription.ExceptionTypeForUI : null,
			errorExceptionType: "",
			notifyMethods: props.editSubscription ? notifyHelper.getNotifyMethods(props.editSubscription.SendEmailNotifications, props.editSubscription.SendPushNotifications, props.editSubscription.SendSmsNotifications, props.editSubscription.SendAppNotifications) : [],
			errorNotifyMethod: "",
			hierarchyId: props.editSubscription ? props.editSubscription.HierarchyId : AuthenticationStore.getLoggedInUser().OrganizationHierarchyId,
			includeChildHierarchies: props.editSubscription ? props.editSubscription.IncludeChildHierarchies : false,
			restrictToDirectReports: props.editSubscription ? props.editSubscription.RestrictToDirectReports : false,
			description: props.editSubscription ? props.editSubscription.Description : "",
			errorDuplicated: ""
		}
		autobind(this)
	}

	handleSave() {
		if (!this.checkValidate()) return
		const subscription: IExtendedUserExceptionNotificationSetting = {
			Id: this.props.editSubscription ? this.props.editSubscription.Id : this.props.existingSubscriptions.length,
			ExceptionTypeForUI: this.state.exceptionType,
			SendEmailNotifications: this.state.notifyMethods.includes(ENotifyMethods.Email),
			SendPushNotifications: this.state.notifyMethods.includes(ENotifyMethods.Push),
			SendAppNotifications: this.state.notifyMethods.includes(ENotifyMethods.App),
			HierarchyId: this.state.hierarchyId ? this.state.hierarchyId : null,
			IncludeChildHierarchies: this.state.includeChildHierarchies,
			RestrictToDirectReports: this.state.restrictToDirectReports,
			Description: this.state.description
		}
		this.props.editSubscription ? this.props.handleUpdate(subscription) : this.props.handleAdd(subscription)
	}

	checkValidate() {
		let isValidate = true
		if (this.state.exceptionType === null) {
			this.setState({ errorExceptionType: strings.This_field_is_required })
			isValidate = false
		}
		else {
			this.setState({ errorExceptionType: "" })
		}

		if (this.state.notifyMethods.length === 0) {
			this.setState({ errorNotifyMethod: strings.This_field_is_required })
			isValidate = false
		}
		else {
			this.setState({ errorNotifyMethod: "" })
		}

		if (this.state.exceptionType !== null && this.state.notifyMethods.length > 0) {
			const existingSubscriptions = this.props.existingSubscriptions.filter(item =>
				this.props.editSubscription ?
					item.ExceptionTypeForUI !== this.props.editSubscription.ExceptionTypeForUI ||
					item.HierarchyId !== this.props.editSubscription.HierarchyId ||
					item.IncludeChildHierarchies !== this.props.editSubscription.IncludeChildHierarchies ||
					item.RestrictToDirectReports !== this.props.editSubscription.RestrictToDirectReports ||
					item.SendAppNotifications !== this.props.editSubscription.SendAppNotifications ||
					item.SendEmailNotifications !== this.props.editSubscription.SendEmailNotifications ||
					item.SendPushNotifications !== this.props.editSubscription.SendPushNotifications :
					true
			)
			const sendEmail = this.state.notifyMethods.includes(ENotifyMethods.Email)
			const sendPush = this.state.notifyMethods.includes(ENotifyMethods.Push)
			const sendApp = this.state.notifyMethods.includes(ENotifyMethods.App)
			const duplicatedSubscription = existingSubscriptions.find(item =>
				item.ExceptionTypeForUI === this.state.exceptionType &&
				(item.HierarchyId ? item.HierarchyId === this.state.hierarchyId : !this.state.hierarchyId) &&
				item.IncludeChildHierarchies === this.state.includeChildHierarchies &&
				item.RestrictToDirectReports === this.state.restrictToDirectReports &&
				item.SendEmailNotifications === sendEmail &&
				item.SendPushNotifications === sendPush &&
				item.SendAppNotifications === sendApp
			)

			if (duplicatedSubscription) {
				this.setState({ errorDuplicated: strings.This_Subscription_is_duplicated })
				isValidate = false
			}
			else {
				this.setState({ errorDuplicated: "" })
			}
		}
		else {
			this.setState({ errorDuplicated: "" })
		}

		return isValidate;
	}

	render() {
		return (
			<div>
				<Dialog
					open
					title={this.props.editSubscription ? strings.Edit_Subscription : strings.Add_Subscription}
					titleStyle={{ paddingLeft: 35, paddingBottom: 10 }}
					actions={[
						<span style={{ fontSize: 19, marginRight: 40, color: red500 }}>
							{this.state.errorDuplicated}
						</span>,
						<FlatButton
							label={strings.CANCEL}
							secondary
							onTouchTap={this.props.handleClose}
						/>,
						<FlatButton
							label={strings.SAVE}
							primary
							onTouchTap={this.handleSave}
						/>
					]}
				>
					<hr />
					<div style={{ paddingLeft: 15, paddingRight: 15 }}>
						<SelectField
							floatingLabelText={strings.Notification_Type}
							value={this.state.exceptionType}
							onChange={(event, index, exceptionType) =>
								this.setState({
									exceptionType,
									restrictToDirectReports: exceptionType === EExceptionUITypes.DeviceStatus ? false : this.state.restrictToDirectReports,
									notifyMethods: exceptionType === EExceptionUITypes.DeviceStatus ? [ENotifyMethods.Email] : this.state.notifyMethods
								}, () =>
									this.checkValidate()
								)
							}
							errorText={this.state.errorExceptionType}
							errorStyle={{ position: "absolute", top: 70 }}
						>
							{EnumValues.getValues(EExceptionUITypes)
								.filter(item => AccountStore.getScheduleEnabled() ? true : !(item as string).includes("schedule"))
								.filter(item => AccountStore.getAccrualsTimeoffEnabled() ? true : item !== EExceptionUITypes.Timeoff)
								.filter(item => !AccountStore.getDisableEmployeeApprovalException() ? true : item !== EExceptionUITypes.NoEmpApprove)
								.filter(item => !AccountStore.getDisableSupervisorApprovalException() ? true : item !== EExceptionUITypes.NoSupApprove)
								.filter(item => AccountStore.getEnableCAMealBreakNotification() ? true : item !== EExceptionUITypes.CAMealBreakException)
								.map((item, index) =>
									<MenuItem
										key={index}
										value={item}
										primaryText={notifyHelper.getExceptionTypeName(item as EExceptionUITypes)}
									/>
								)}
						</SelectField>
						<div style={{ marginTop: 15 }}>
							<NotifyMethodsChip
								readonly={this.state.exceptionType === EExceptionUITypes.DeviceStatus}
								notifyMethods={this.state.notifyMethods}
								error={this.state.errorNotifyMethod}
								handleChange={notifyMethods => this.setState({ notifyMethods }, () => this.checkValidate())}
							/>
						</div>
						<TextField
							floatingLabelText={strings.Description}
							style={{ width: "85%" }}
							value={this.state.description}
							onChange={(e, value) => this.setState({ description: value })}
						/>
						<div style={{ marginTop: 20, display: "flex" }}>
							<div style={{ width: "45%" }}>
								<ChooseHierarchyChip
									chipLabel={strings.Hierarchy}
									hierarchyItemId={this.state.hierarchyId}
									handleSelectHierarchy={hierarchyId => this.setState({ hierarchyId })}
								/>
							</div>
							<Toggle
								toggled={this.state.includeChildHierarchies}
								onToggle={(e, value) => this.setState({ includeChildHierarchies: value })}
								label={strings.Include_Child_Hierarchies}
								style={{ width: 250, marginTop: 25 }}
							/>
						</div>
						{this.state.exceptionType !== EExceptionUITypes.DeviceStatus &&
							AccountStore.getSupervisorDirectReportEnabled() &&
							<Toggle
								toggled={this.state.restrictToDirectReports}
								onToggle={(e, value) => this.setState({ restrictToDirectReports: value })}
								label={strings.Direct_Reports_Only}
								style={{ width: 250, marginTop: 25 }}
							/>
						}
					</div>
				</Dialog>
			</div>
		)
	}
}